import axios from '../axios-config.js';

/**
 * Envia o arquivo CSV para importação de tabela IBPT.
 * @param {FormData} formData — deve conter `uf` (string) e `file` (File)
 * @returns {Promise<{ arquivo, uf, totalLinhas, inseridos, erros, mensagensErro }>}
 */
export async function importIbptTable(formData) {
    const response = await axios.post('/admin/ibpt/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
}
